import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../hooks/use-theme';

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={`Cambiar a modo ${theme === 'light' ? 'oscuro' : 'claro'}`}
      className={`relative inline-flex items-center justify-center w-9 h-9 rounded-lg border border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:text-brand-primary dark:hover:text-brand-primary hover:border-neutral-300 dark:hover:border-neutral-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary transition-all duration-200 ${className}`}
    >
      {theme === 'light' ? (
        <Moon className="w-4 h-4 transition-transform duration-200 hover:rotate-12" />
      ) : (
        <Sun className="w-4 h-4 transition-transform duration-200 hover:rotate-45 text-amber-400" />
      )}
    </button>
  );
};
